/**
 * Fermat Bundle Utility
 * 
 * Enhanced bundle processing utilities that integrate Fermat cart data
 * with the existing Ritual bundle system.
 */

import { getBundleCartLimit } from './bundle';
import { 
  readFermatCookie, 
  mapFermatToRitual
} from './fermatCookie';

/**
 * Get Fermat cart products in Ritual format
 * @returns Array of products ready for cart addition
 */
export function getFermatCartProducts(): Array<{
  planId: string;
  quantity: number;
  variantId?: string;
  productId?: string;
}> | null {
  const fermatData = readFermatCookie();
  if (!fermatData) {
    return null;
  }
  
  const ritualData = mapFermatToRitual(fermatData);
  const productLimit = getBundleCartLimit();
  
  return ritualData.products.slice(0, productLimit);
}

/**
 * Get discount codes from Fermat cart
 * @returns Array of discount codes or empty array if none
 */
export function getFermatDiscountCodes(): string[] {
  const fermatData = readFermatCookie();
  
  if (!fermatData) {
    return [];
  }
  
  const discountCodes = fermatData.discount_codes || [];
  
  return discountCodes;
}

/**
 * Get Fermat attribution data
 * @returns Attribution object or null if no Fermat cart
 */
export function getFermatAttribution(): {
  vendor: string;
  sourceCode: string;
  checkoutId: string;
} | null {
  const fermatData = readFermatCookie();
  if (!fermatData) {
    return null;
  }
  
  return {
    vendor: fermatData.metadata.vendor,
    sourceCode: fermatData.metadata.source_code,
    checkoutId: fermatData.id,
  };
}
